import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=b87a1606&scoped=true&"
import script from "./DetailList.vue?vue&type=script&lang=js&"
export * from "./DetailList.vue?vue&type=script&lang=js&"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=b87a1606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a1606",
  null
  
)

export default component.exports